// extracted by mini-css-extract-plugin
module.exports = {"coursesPage":"CoursesPage_coursesPage__26M-o","coursesBlock":"CoursesPage_coursesBlock__1YUkP"};